import service from "./service";
import ParameterSettings from "./apis/ParameterSettings";
import home from "./apis/home";
import list from "./apis/list";
import PermissionManagement from "./apis/PermissionManagement";
import AppVersionAdmin from "./apis/AppVersionAdmin";
import DeviceReadingAgent from "./apis/DeviceReadingAgent";
import QuestionAnswerAgent from "./apis/QuestionAnswerAgent";
import DeviceReadingDataset from "./apis/DeviceReadingDataset";
import SystemMonitor from "./apis/SystemMonitor";

// API 模块类型定义 - 使用宽松类型以兼容各种 API 签名
type ApiModule = Record<string, (...args: never[]) => Promise<unknown>>;

// 兼容性层：保持 getData 以支持未修改的组件
const apiMap: Record<string, ApiModule> = {
    ParameterSettings: ParameterSettings as ApiModule,
    home: home as ApiModule,
    list: list as ApiModule,
    PermissionManagement: PermissionManagement as ApiModule,
    AppVersionAdmin: AppVersionAdmin as unknown as ApiModule,
    DeviceReadingAgent: DeviceReadingAgent as unknown as ApiModule,
    QuestionAnswerAgent: QuestionAnswerAgent as unknown as ApiModule,
    DeviceReadingDataset: DeviceReadingDataset as unknown as ApiModule,
    SystemMonitor: SystemMonitor as unknown as ApiModule
};

async function getData<T = unknown>(keyName: string, ...args: unknown[]): Promise<T> {
    // keyName 格式如 "ParameterSettings/parameterSettingsListIndex"
    const [moduleName, methodName] = keyName.split('/');
    
    const module = apiMap[moduleName];
    if (!module) {
        throw new Error(`Module "${moduleName}" not found in API map.`);
    }
    
    const method = module[methodName];
    if (!method || typeof method !== 'function') {
        throw new Error(`Method "${methodName}" not found in module "${moduleName}".`);
    }
    
    // 直接调用方法，现在它们返回 Promise
    return (method as (...args: unknown[]) => Promise<T>)(...args);
}

// 导出所有 API 模块，供组件显式引用
export {
    service,
    ParameterSettings,
    home,
    list,
    PermissionManagement,
    AppVersionAdmin,
    DeviceReadingAgent,
    QuestionAnswerAgent,
    DeviceReadingDataset,
    SystemMonitor
};

// 默认导出 getData 保持兼容性
export default getData;
